import React from 'react'
import PropTypes from 'prop-types'
import MemberSearchContainer from '../containers/member_search_container'
import ShareButton from './share_button'
import OrientationButton from './orientation_button'
import {isMobileSurface} from '../utils/device_utils'
import {VIEW_MODES} from '../constants'

// The member-search / share / orientation action cluster. Web renders it in
// the top bar next to the round selector mobile and landscape render it on
// the selected tile's event-header line.
const HeaderActions = ({
  viewMode, leagueName, showLinkCopied, showLinkCopyFailed, showRotateHint, markRotateHintUsed,
  isOrientationLocked, setOrientationLocked,
}) => {
  const onMobileDevice = isMobileSurface()

  return (
    <div className="lbv2__header-actions">
      {/* Header search is web-only; mobile and landscape get it inside the
          events modal, so the gate follows viewMode, not the device sniff. */}
      {viewMode === VIEW_MODES.WEB && <MemberSearchContainer/>}
      {onMobileDevice && (
        <OrientationButton
          viewMode={viewMode}
          isLocked={isOrientationLocked}
          setIsLocked={setOrientationLocked}
          showRotateHint={showRotateHint}
          markRotateHintUsed={markRotateHintUsed}/>
      )}
      <ShareButton
        leagueName={leagueName}
        showLinkCopied={showLinkCopied}
        showLinkCopyFailed={showLinkCopyFailed}/>
    </div>
  )
}

HeaderActions.propTypes = {
  viewMode: PropTypes.oneOf(Object.values(VIEW_MODES)),
  leagueName: PropTypes.string,
  showLinkCopied: PropTypes.func.isRequired,
  showLinkCopyFailed: PropTypes.func.isRequired,
  showRotateHint: PropTypes.func.isRequired,
  markRotateHintUsed: PropTypes.func.isRequired,
  isOrientationLocked: PropTypes.bool.isRequired,
  setOrientationLocked: PropTypes.func.isRequired,
}

export default HeaderActions
